export const num = (v) => (v == null ? '—' : Number(v).toLocaleString('en-IN'));
export const pct = (v, digits = 1) => (v == null ? '—' : `${(v * 100).toFixed(digits)}%`);
export const money = (v) =>
  (v == null ? '—' : `₹${Number(v).toLocaleString('en-IN', { maximumFractionDigits: 0 })}`);

// Three kinds of number, and they must never read the same. Actual is
// Amazon's own figure, allocated is split out of an actual by a stated rule,
// and absent is neither.
export const BASIS_LABEL = {
  actual: 'Amazon’s figure',
  allocated: 'allocated by us',
  estimated: 'estimated',
};
